// Blog post images
import soc2HeroImage from "@/images/blog/soc2/soc2_hero.webp";
import soc2ListingImage from "@/images/blog/soc2/soc2_listing.webp";
import aiE2eTestingHeroImage from "@/images/blog/ai-e2e-testing/ai-testing-hero.webp";
import aiE2eTestingListingImage from "@/images/blog/ai-e2e-testing/ai-testing-listing.webp";
import allThePipelinesHeroImage from "@/images/blog/all-the-pipelines/hero.svg";
import createZephyrAppsHeroImage from "@/images/blog/create-zephyr-apps/hero.webp";
import infrastructurelessHeroImage from "@/images/blog/infrastructureless/hero.webp";
import mobilefirstHeroImage from "@/images/blog/mobilefirst/hero.webp";
import otaWithZephyrHeroImage from "@/images/blog/ota-with-zephyr/ota-hero.webp";
import serveTimeHeroImage from '@/images/blog/serve-time/hero.webp';
import sgwsCaseStudyHeroImage from "@/images/blog/sgws-case-study/case-study-sgws.webp";
import teamFirstArchitectureHeroImage from "@/images/blog/the-team-first-architecture/the-team-first-architecture.webp";
import threeSdlcsOneZephyrHeroImage from "@/images/blog/three-sdlcs-one-zephyr/three-sdlc-one-zephyr.svg";
import vibeCodingHeroImage from "@/images/blog/vibe-coding/vibe-coding.webp";
import runtimeOtaHeroImage from "@/images/blog/runtime-ota/runtime-ota.webp";
import whosYourCloudDaddyHeroImage from "@/images/blog/whos-your-cloud-daddy/cloud-daddy-hero.webp";
import blogPostAwsHeroImage from '@/images/blog/aws-byoc/blog-post-aws.webp';

export const blogImages = {
  soc2: {
    heroImage: soc2HeroImage,
    listingImage: soc2ListingImage,
  },
  "ai-e2e-testing": {
    heroImage: aiE2eTestingHeroImage,
    listingImage: aiE2eTestingListingImage,
  },
  "all-the-pipelines": {
    heroImage: allThePipelinesHeroImage,
    listingImage: allThePipelinesHeroImage,
  },
  "create-zephyr-apps": {
    heroImage: createZephyrAppsHeroImage,
    listingImage: createZephyrAppsHeroImage,
  },
  "infrastructureless": {
    heroImage: infrastructurelessHeroImage,
    listingImage: infrastructurelessHeroImage,
  },
  "mobilefirst": {
    heroImage: mobilefirstHeroImage,
    listingImage: mobilefirstHeroImage,
  },
  "ota-with-zephyr": {
    heroImage: otaWithZephyrHeroImage,
    listingImage: otaWithZephyrHeroImage,
  },
  "serve-time": {
    heroImage: serveTimeHeroImage,
    listingImage: serveTimeHeroImage,
  },
  "sgws-case-study": {
    heroImage: sgwsCaseStudyHeroImage,
    listingImage: sgwsCaseStudyHeroImage,
  },
  "the-team-first-architecture": {
    heroImage: teamFirstArchitectureHeroImage,
    listingImage: teamFirstArchitectureHeroImage,
  },
  "three-sdlcs-one-zephyr": {
    heroImage: threeSdlcsOneZephyrHeroImage,
    listingImage: threeSdlcsOneZephyrHeroImage,
  },
  "vibe-coding": {
    heroImage: vibeCodingHeroImage,
    listingImage: vibeCodingHeroImage,
  },
  "week-3-runtime-ota": {
    heroImage: runtimeOtaHeroImage,
    listingImage: runtimeOtaHeroImage,
  },
  "whos-your-cloud-daddy": {
    heroImage: whosYourCloudDaddyHeroImage,
    listingImage: whosYourCloudDaddyHeroImage,
  },
  'aws-byoc': {
    heroImage: blogPostAwsHeroImage,
    listingImage: blogPostAwsHeroImage,
  },
};
